import { handleActions, combineActions } from 'redux-actions'

import * as rawActions from '../actions'

const defaultState = false

export default handleActions(
  {
    [combineActions(rawActions.getAiObjectsWithStatistics.request)](state, action) {
      return true
    },
    [combineActions(rawActions.getAiObjectsWithStatistics.success)](state, action) {
      return false
    },
    [rawActions.resetState](state, payload) {
      return defaultState
    },
  },
  defaultState
)
